// src/data/stats.js
const stats = [
  { value: '500+', label: 'Довольных клиентов' },
  { value: '24/7', label: 'Поддержка клиентов' },
  { value: '99%', label: 'Качество продукции' },
  { value: '48ч', label: 'Быстрая доставка' },
];

export default stats;
